import type { AnalyticsSettings, ChartSettings } from 'models/analytics/chartSettings';

const getDefaultChartSettings = (): ChartSettings => {
  const from = new Date();
  from.setMonth(from.getMonth() - 6);
  from.setDate(1);
  from.setHours(0);
  from.setMinutes(0);
  from.setSeconds(0);
  from.setMilliseconds(0);

  return {
    groupBy: 'month' as const,
    dateRange: {
      from,
      to: new Date(),
    },
  };
};

export const getDefaultAnalyticsSettings = (): AnalyticsSettings => ({
  orders: getDefaultChartSettings(),
  revenue: getDefaultChartSettings(),
});
